// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SemainesSchedulerDate_disabled__2jxxk {\n  opacity: 0.4\n}\n.SemainesSchedulerDate_color__3GhOq {\n  color: var(--background-creneau-normal);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Semaines/SemainesSchedulerDate.module.css"],"names":[],"mappings":"AAAA;EACE;AACF;AACA;EACE,uCAAuC;AACzC","sourcesContent":[".disabled {\n  opacity: 0.4\n}\n.color {\n  color: var(--background-creneau-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": "SemainesSchedulerDate_disabled__2jxxk",
	"color": "SemainesSchedulerDate_color__3GhOq"
};
export default ___CSS_LOADER_EXPORT___;
